import { cn } from "@/lib/utils";
import { useState } from "react";

interface ResponsiveVideoProps {
  src: string;
  poster?: string;
  loop?: boolean;
  className?: string;
  /** Max height for portrait (height > width) videos, e.g. drawer previews. */
  portraitMaxHeight?: string;
  /** Max height for landscape videos (px). */
  landscapeMaxHeight?: number;
}

/**
 * Video preview that keeps the file's native aspect ratio (portrait or landscape).
 */
export const ResponsiveVideo = ({
  src,
  poster,
  loop,
  className,
  portraitMaxHeight,
  landscapeMaxHeight,
}: ResponsiveVideoProps) => {
  const [isPortrait, setIsPortrait] = useState(false);

  return (
    <video
      src={src}
      poster={poster}
      controls
      loop={loop}
      playsInline
      className={cn(
        "w-full h-auto max-w-full rounded-md object-contain bg-black/5",
        className,
      )}
      style={{
        maxHeight:
          isPortrait && portraitMaxHeight
            ? portraitMaxHeight
            : landscapeMaxHeight !== undefined
              ? landscapeMaxHeight
              : undefined,
      }}
      onLoadedMetadata={(event) => {
        const { videoWidth, videoHeight } = event.currentTarget;
        if (videoWidth > 0 && videoHeight > 0) {
          setIsPortrait(videoHeight > videoWidth);
        }
      }}
    />
  );
};
